export const removeNullishObjectProperties = <T extends Record<string, unknown>>(object: T): T => {
  return Object.fromEntries(Object.entries(object).filter(([, value]) => value !== null && value !== undefined)) as T;
};
